import axios from 'axios'
import { GetQueryString } from 'src/frontend-lib/tools/utils'
import { getRequestSign } from 'src/frontend-lib/tools/platformSign'
import qs from 'qs'

export function getBaseParams() {
  let _version = GetQueryString('_version', window.location.hash)
  let _platform = GetQueryString('_platform', window.location.hash)
  return {
    _version: _version || '6.1.0',
    _platform: _platform || 'ios'
  }
}

export const getWithSign = (url, params) => {
  let baseParams = getBaseParams()
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)
  console.log('getWithSigngetWithSign', platFormSign)
  return axios.get(url, {
    params: Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
  })
}

export const postWithSign = (url, params) => {
  let baseParams = getBaseParams()
  let _params = Object.assign({}, baseParams, params)
  let platFormSign = getRequestSign(_params)
  return axios.post(
    url,
    qs.stringify(
      Object.assign(platFormSign.params, {
        sign: platFormSign.sign
      })
    ),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/yiapiRequest.js